const defaultState = {
  customers: null,
  error: null,
  fetching: false,
  fetched: false
};

const getStateCountryReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'STATE_COUNTRY_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true
      };
    }
    case 'STATE_COUNTRY_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, stateCountry: action.payload.data
      };
    }
    case 'STATE_COUNTRY_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        customers: null,
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getStateCountryReducer;


// WEBPACK FOOTER //
// ./src/reducers/getStateCountry.js